import { LOCALES } from 'oura-account-api/src/types';

export const setLocalLanguage = () => {
  const browserLang = navigator.languages?.[0] || navigator.language || 'en';
  const norm = browserLang.toLowerCase().replace('_', '-');
  const locale = norm.split('-')[0];
  document.documentElement.lang = (LOCALES as readonly string[]).includes(locale) ? locale : 'en';
};
